// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yD6-f","wrapper__opened":"styles_wrapper__opened__DyZz+"};